/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.14.0
 * @since 1.14.0
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./components/WizardChangeLock'));
